module.exports = __webpack_public_path__ + "img/5c41f3e.png";